export default __webpack_public_path__ + "media/images/mailer/logo-50cfb97cbce11d4974c71481a924b69c.png";